var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2215 1.06838C14.2215 1.06838 15.609 0.527282 15.4929 1.84126C15.4547 2.38236 15.1079 4.27636 14.8379 6.32466L13.9129 12.3928C13.9129 12.3928 13.8357 13.2817 13.1418 13.4364C12.4482 13.5907 11.4074 12.8953 11.2146 12.7406C11.0603 12.6245 8.32372 10.8852 7.36012 10.0352C7.0901 9.80301 6.78152 9.33942 7.39869 8.79832L11.4456 4.93317C11.9082 4.46958 12.3707 3.3874 10.4435 4.70138L5.04681 8.37295C5.04681 8.37295 4.43 8.75975 3.27388 8.41188L0.768068 7.63864C0.768068 7.63864 -0.156969 7.05897 1.42345 6.4793C5.27825 4.6628 10.0195 2.80773 14.2207 1.06838H14.2215Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.043f5d3d4c43d75e2bbc653d0b9d23ce.svg";
export { ForwardRef as ReactComponent };